/**
 * Confirmation modal dialog.
 * @module ui/modal
 */

/**
 * Shows a confirmation dialog and returns the user's choice.
 * @param {string} message - Confirmation message to display
 * @returns {Promise<boolean>} true if user confirmed, false if cancelled
 */
export function showConfirm(message) {
  return new Promise((resolve) => {
    const overlay = document.getElementById("confirm-overlay");
    document.getElementById("confirm-message").textContent = message;
    overlay.style.display = "flex";
    document.getElementById("confirm-yes").onclick = () => { overlay.style.display = "none"; resolve(true); };
    document.getElementById("confirm-no").onclick  = () => { overlay.style.display = "none"; resolve(false); };
  });
}
